import {Link} from 'react-router-dom';
import {useParams} from 'react-router-dom';
import {useState,useEffect} from 'react';
import axios from "axios";
import {baseUrl, userLocation, ipAddress, userName} from '../Univ.js'
function CrmMenu(){
const userGroup= localStorage.getItem('userGroup');
    return (
        <section className="container mt-4">
            <div className="row nurseInpatient">
                <div className='col-md-12 col-12'>
                    <div className="row">
                    <div className="col-md-12 company-info">
                    <div className="panel panel-primary">
                    <div className="panel-heading">
                    <h4 className="panel-title" >CRM System</h4>
                    </div>
                    </div>
                    </div>
                    </div>

                    <div className="row">
                    <div className="col-md-12 company-info mb-3">
                    <div className="btn-group">
                    <a href="/lead-list"><button type="button" className="btn btn"><span >Lead List</span></button></a></div>
                    </div>
                    </div>

               </div>
            </div>
        </section>
    )
}

export default CrmMenu;